import type { Components, Theme } from "@mui/material/styles";

export const MuiTooltip: Components<Theme>["MuiTooltip"] = {
  styleOverrides: {
    tooltip: () => ({
      fontSize: ".8rem",
      backgroundColor: `light-dark(var(--mui-palette-grey-300), var(--mui-palette-grey-600))`,
    }),
    arrow: () => ({
      color: `light-dark(var(--mui-palette-grey-300), var(--mui-palette-grey-600))`,
    }),
  },
};
